import { ApiError } from './client/apiClient';

// rpjava app/hotpads-api/server/src/main/java/com/hotpads/hotpadsapi/facade/result/{HpApiResult,BaseRestResult}.java
export type HpApiV2Result<T> = {
  success?: boolean;
  status?: string;
  message?: string | null;
  loggedIn?: boolean;
  data?: T | null;
};

export class HpApiV2ResultError extends ApiError {
  resultStatus?: string;

  constructor(message: string, result: HpApiV2Result<unknown>) {
    super(message, { data: result });
    this.name = 'HpApiV2ResultError';
    this.category = 'API_DATA_ERROR';
    this.resultStatus = result.status;
  }
}

/** V2 endpoints answer HTTP 200 with `success: false` on failure, which apiClient does not reject. */
export function assertHpApiV2Success<R extends HpApiV2Result<unknown> | null | undefined>(result: R, action: string): R {
  if (result?.success === false) {
    throw new HpApiV2ResultError(result.message || result.status || `hotpads-api rejected ${action}`, result);
  }
  return result;
}
